<app-data-grid-comp
    [columns]="columns"
    [bindingType]="bindingType"
    [view]="view"
    [gridData]="gridData"
    [gridDataResult]="gridDataResult"
    [isLoading]="isLoading"
    [pageSize]="pageSize"
    [skip]="skip"
    category="Grievances"
    [isLoading]="isLoading"
    (emitPageChangeEvent)="pageChange($event)"
    (emitOpenDialogEvent)="openEmploymentRecordGrievanceDialog($event)"
    (emitDeleteEvent)="deleteEmploymentRecordGrievance($event)"
></app-data-grid-comp>